export default "__VITE_ASSET__57acd18a__"